import './style.sass';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import parse from 'html-react-parser';

import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import SimpleSlider from '../slider/';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonSmallText from '../../../common-components/common-small-text';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonOlList from '../../../common-components/common-ol-list';
import CommonCollapseItem from '../../../common-components/common-collapse-item';

const firstItemList = {
    colorNumber: '#157fc4',
    list: [
        'Для родителей,',
        'Для учителей,',
        'Для выпускников 9&nbsp;классов,',
        'Для тех, кто заканчивал 11&nbsp;класс.',
    ],
};

const secondItemList = [
    {
        title: 'Другие материалы для рекламной кампании',
        subtitle: `<div class="mid-process-spoiler__img-container">
                        <div class="mid-process-spoiler__img"><img src="/images/pic/mid/process3-1.png" alt="" loading='lazy'></div>
                    </div>
                    <div class="mid-process-spoiler__small-text">
                    Реклама в&nbsp;Яндекс.Директ
                    </div>
                    <div class="mid-process-spoiler__img-container">
                        <div class="mid-process-spoiler__img"><img src="/images/pic/mid/process3-2.png" alt="" loading='lazy'></div>
                    </div>
                    <div class="mid-process-spoiler__small-text">
                    Реклама в&nbsp;Яндекс.Директ
                    </div>
                    <div class="mid-process-spoiler__img-container">
                        <div class="mid-process-spoiler__img"><img src="/images/pic/mid/process3-3.png" alt="" loading='lazy'></div>
                    </div>
                    <div class="mid-process-spoiler__small-text">
                    Таблица с&nbsp;семантикой
                    </div>`,
    },
];

const fourthItemList = {
    colorNumber: '#157fc4',
    list: [
        'Запустили рекламные кампании на&nbsp;Youtube с&nbsp;целью широкого взаимодействия с&nbsp;целевой аудиторией по&nbsp;демографическим, социальным и&nbsp;гео-признакам.',
        'Настроили радиус и&nbsp;показ перед популярными каналами, которые смотрит наша целевая аудитория.',
        'Использовали несколько рабочих форматов, таких как объявления In-stream с&nbsp;пропуском и&nbsp;без возможности пропуска, Out-stream.',
    ],
};

const firstSlider = [
    { img: '/images/pic/mid/slider1.png' },
    { img: '/images/pic/mid/slider2.png' },
    { img: '/images/pic/mid/slider3.png' },
];

const Process = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper bigPaddings={true} className="mid-process">
                <CommonTitle>Процесс</CommonTitle>

                <CommonUsualText className="mid-process__title">
                    Несколько раз в&nbsp;году, когда колледж устраивает дни открытых дверей
                    и&nbsp;ждет абитуриентов, мы&nbsp;подключаемся к&nbsp;активностям
                    и&nbsp;помогаем собрать заявки на&nbsp;поступление. Сам процесс подготовки
                    рекламных кампаний ко&nbsp;дню открытых дверей и&nbsp;финальному сбору заявок
                    от&nbsp;абитуриентов состоял из&nbsp;аналогичных этапов, но&nbsp;с&nbsp;разными
                    офферами. В&nbsp;итоге мы&nbsp;разделили работу на&nbsp;несколько этапов:
                </CommonUsualText>

                <div className="mid-process__container">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="mid-process__item mid-process__item--reverse"
                    >
                        <div className="mid-process__item-img">
                            <img
                                src="/images/pic/mid/frame.png"
                                alt="Поисковая оптимизация"
                                title="Поисковая оптимизация"
                                loading="lazy"
                            />
                        </div>
                        <div className="mid-process__item-info">
                            <CommonSmallTitle className="mid-process__item-title">
                                01. Разработка стратегии, подборка гипотез, подготовка офферов
                            </CommonSmallTitle>
                            <CommonSmallText className="mid-process__item-text">
                                На&nbsp;этом этапе мы&nbsp;занимались разработкой стратегии,
                                подборкой гипотез для тестирования&nbsp;РК, сбором целевой семантики
                                для поисковой рекламы и&nbsp;около целевой для запуска рекламных
                                кампаний в&nbsp;сетях Яндекса. Также создавали офферы для разных
                                целевых аудиторий, которые были рассчитаны на&nbsp;тех, кто еще
                                не&nbsp;был знаком с&nbsp;Колледжем, для тех, кто просто
                                интересовался поступлением, и&nbsp;для тех, кто хотел поступить
                                именно в&nbsp;этот колледж.
                            </CommonSmallText>
                            <br />
                            <CommonSmallText className="mid-process__item-text">
                                В&nbsp;результате подготовили офферы для 4&nbsp;целевых аудиторий:
                            </CommonSmallText>
                            <CommonOlList
                                className="mid-process__item-list"
                                CommonOlList={firstItemList}
                            />
                        </div>
                    </ScrollAnimation>

                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="mid-process__item"
                    >
                        <div className="mid-process__item-slider">
                            <SimpleSlider info={firstSlider} />
                        </div>
                        <div className="mid-process__item-info">
                            <CommonSmallTitle className="mid-process__item-title">
                                02. Таргетированная реклама в&nbsp;соцсетях
                            </CommonSmallTitle>
                            <CommonSmallText className="mid-process__item-text">
                                Промотировали посты в&nbsp;официальных социальных сетях колледжа
                                ВКонтакте и&nbsp;Instagram (в&nbsp;ленте и&nbsp;stories).
                                На&nbsp;каждую целевую аудиторию запустили по&nbsp;два варианта
                                рекламы&nbsp;&mdash; со&nbsp;сбором заявок и&nbsp;с&nbsp;записью
                                через сайт, чтобы протестировать, какой формат лучше подойдет
                                нашей&nbsp;ЦА.
                            </CommonSmallText>
                        </div>
                    </ScrollAnimation>

                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="mid-process__item mid-process__item--reverse"
                    >
                        <div className="mid-process__item-img">
                            <img
                                src="/images/pic/mid/contextadd.png"
                                alt="Контекстная реклама"
                                title="Контекстная реклама"
                                loading="lazy"
                            />
                            <div className="mid-process__small-text">
                                Текстово-графическая реклама
                            </div>
                            {secondItemList.map(({ title, subtitle }, index) => (
                                <CommonCollapseItem
                                    key={++index}
                                    index={++index}
                                    isNumber={false}
                                    triggerText={title}
                                    content={parse(subtitle)}
                                    classParent={'mid-process__collapse-item'}
                                    numberColor={'#00529d'}
                                />
                            ))}
                        </div>
                        <div className="mid-process__item-info">
                            <CommonSmallTitle className="mid-process__item-title">
                                03. Контекстная реклама в&nbsp;РСЯ, на&nbsp;поиске Яндекс.Директ,
                                текстово-графические и&nbsp;графические объявления
                            </CommonSmallTitle>
                            <CommonSmallText className="mid-process__item-text">
                                Для запуска контекстной рекламы мы&nbsp;собрали семантику,
                                подготовили тексты и&nbsp;визуалы для объявлений, минусовали
                                нецелевые запросы и&nbsp;площадки ежедневно.
                            </CommonSmallText>
                        </div>
                    </ScrollAnimation>

                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="mid-process__item"
                    >
                        <div className="mid-process__item-img">
                            <img
                                src="/images/pic/mid/quiz.png"
                                alt="Квиз"
                                title="Квиз"
                                loading="lazy"
                            />
                        </div>
                        <div className="mid-process__item-info">
                            <CommonSmallTitle className="mid-process__item-title">
                                04. Подключили дополнительный источник сбора заявок&nbsp;&mdash;
                                квиз.
                            </CommonSmallTitle>
                            <CommonSmallText className="mid-process__item-text">
                                Разработали и&nbsp;подключили на&nbsp;сайт квиз и&nbsp;поместили его
                                на&nbsp;главную страницу. Он&nbsp;помогает пользователям оставить
                                свои данные в&nbsp;игровой форме, что позволяет проще выбрать
                                программы обучения и&nbsp;оставить заявку.
                            </CommonSmallText>
                        </div>
                    </ScrollAnimation>

                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="mid-process__item mid-process__item--reverse"
                    >
                        <div className="mid-process__item-img">
                            <img src="/images/pic/mid/quiz.png" alt="" loading="lazy" />
                        </div>
                        <div className="mid-process__item-info">
                            <CommonSmallTitle className="mid-process__item-title">
                                05. Задействовали видеокампании на&nbsp;YouTube
                            </CommonSmallTitle>
                            <CommonOlList
                                className="mid-process__item-list"
                                CommonOlList={fourthItemList}
                            />
                        </div>
                    </ScrollAnimation>

                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="mid-process__item"
                    >
                        <div className="mid-process__item-video">
                            <iframe
                                allowFullScreen
                                title="Запустили еще одну рекламную кампанию на&nbsp;сэкономленные деньги"
                                width="100%"
                                height="315"
                                src="https://www.youtube.com/embed/TgDJErbX978"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            />
                        </div>
                        <div className="mid-process__item-info">
                            <CommonSmallTitle className="mid-process__item-title">
                                06. Запустили еще одну рекламную кампанию на&nbsp;сэкономленные
                                деньги.
                            </CommonSmallTitle>
                            <CommonSmallText className="mid-process__item-text">
                                У&nbsp;нас остался бюджет после выполнения KPI,
                                и&nbsp;мы&nbsp;решили провести дополнительные рекламные кампании
                                по&nbsp;привлечению абитуриентов на&nbsp;подготовительные курсы
                                колледжа. Для этого взяли те&nbsp;же целевые аудитории, которые
                                состояли из&nbsp;родителей, учителей и&nbsp;детей.
                                Но&nbsp;в&nbsp;этой кампании нас интересовала другая возрастная
                                группа детей&nbsp;&mdash; ученики 8-9&nbsp;классов, которые состояли
                                в&nbsp;пабликах по&nbsp;подготовке к&nbsp;экзаменам.
                            </CommonSmallText>
                        </div>
                    </ScrollAnimation>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Process;
